import { ReactNode } from 'react';

export enum CustomerAccessSetupSteps {
  SALES_ORDERS,
  USER,
}

export type CustomerAccessSetupPageContext = {
  setStep: (value: CustomerAccessSetupSteps) => void;
  setHeaderButton: (value: ReactNode) => void;
};
